import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import CitiesServices from "services/Admin/CitiesService"
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import { SuccessOk } from 'configs/statusCode';
import { toast } from 'react-toastify';
import { adminPrefix } from 'configs/routePrefix';
import AreaModal from "../AreaModal"
import { useSelector } from "react-redux"
import DeleteModal from '../DeleteModal';

const CardItem = (props) => {
    const { index, item, id, name, email, setShouldGetData, status, Service } = props
    const [areaModal, setAreaModal] = useState(false)
    const [type, setType] = useState()
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const [deleteModal, setDeleteModal] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [itemStatus, setItemStatus] = useState(false);

    const service = new Service
    const toggle = () => setDropdownOpen(prevState => !prevState);

    useEffect(() => {
        setItemStatus(status)

    }, [status])
    const handleCloseModal = (action, response) => {
        setDeleteModal(false);
        if (action === "delete") {
            setShouldGetData(true)
        }
    };


    const changeStatus = (e) => {
        const value = e.target.checked
        service.toggleStatus(id).then((res) => {
            if (res && res.status === SuccessOk) {
                setItemStatus(value)
                toast.success("Change status successfully");
                setTimeout(() => {
                    setShouldGetData(true)
                }, 1000);
            }
        });
    }
    return (
        <tr key={index}>
            <td className='font-size-16'>{item.id}</td>
            <td className='font-size-16'>{item.name}</td>
            <td className='font-size-16'>{email}</td>
            <td className='font-size-16'>{item.number_of_leads}</td>
            <th className='font-size-14'> {item.assigned_compounds.map((comp, index) => {
                return (
                    <div key={index}   >
                        <Badge className="bgBadge font-size-14 mt-0 m-1"
                            style={{ background: "#50a5f1", color:"#556EE6", marginTop: "0px !important" }}>{comp}</Badge> <br />
                    </div>
                )
            })}</th>
            <th className='font-size-14'> {item.assigned_areas.map((area, index) => {
                return (
                    <div key={index} >
                        <Badge
                            className="bgBadge font-size-14 mt-0 m-1"
                            style={{ background: "#50a5f1", color:"#556EE6", marginTop: "0px !important" }}
                        >{area}</Badge> <br />
                    </div>
                )
            })}</th>
            {isExist("salesRep.edit") ? <th className='font-size-14 py-0'>
                <form>
                    <div className='form-check form-switch form-switch-md mb-1'>
                        <input
                            name='status'
                            checked={itemStatus}
                            type='checkbox'
                            className='form-check-input'
                            id='has_status'
                            onChange={changeStatus}
                            disabled={isExist("salesRep.edit") ? false : true}
                        />
                    </div>
                </form>
            </th> : null}
            <td className="removebtnhover">
                <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle caret>
                        <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem onClick={() => {
                            props.history.push(`${adminPrefix}/sales-rep/sales-rep-profile/${item.id}`)
                        }}>View</DropdownItem>
                        {isExist("salesRep.edit") ? <DropdownItem onClick={() => {
                            props.history.push(`${adminPrefix}/sales-rep/invite-sales-rep/${item.id}`)
                        }}>Edit </DropdownItem> : null}
                        {isExist("salesRep.edit") ? <DropdownItem onClick={() => {
                            setType("Area")
                            setAreaModal(true)
                        }}>Assign Locations</DropdownItem> : null}
                        {isExist("salesRep.edit") ? <DropdownItem onClick={() => {
                            setType("Compound")
                            setAreaModal(true)
                        }}>Assign Compounds</DropdownItem> : null}
                        {isExist("salesRep.delete") ? <DropdownItem onClick={() => {
                            setDeleteModal(!deleteModal);
                        }}><p className="mb-0 pb-0 text-danger">Remove Sales Rep</p></DropdownItem> : null}
                    </DropdownMenu>
                </Dropdown>
            </td>
            {areaModal ? <AreaModal
                modal={areaModal}
                setShouldGetData={setShouldGetData}
                type={type}
                toggle={() => setAreaModal(!areaModal)}
                id={item.id}
                salesRep={{ label: item.name, value: item.id }}
            /> : null}
            {deleteModal && <DeleteModal
                open={deleteModal}
                deletedItem={item}
                modelService={service}
                setShouldGetData={setShouldGetData}
                onCloseModal={(action) => handleCloseModal(action)}
            />}
        </tr>



    );
}

export default CardItem;